Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    checkboxMotionDuration: "100ms",
    checkboxMotionFunction: "ease",
    checkboxForegroundColorDefault: tokens.themeInkDefault,
    checkboxForegroundColorDisabled: tokens.themeInkDisabled,
    checkboxBackgroundColorSelectedDefault: tokens.themeActionPrimaryDefault,
    checkboxBackgroundColorSelectedHover: tokens.themeActionPrimaryHover,
    checkboxBackgroundColorSelectedPressed: tokens.themeActionPrimaryPressed,
    checkboxBackgroundColorSelectedDisabled: tokens.themeActionPrimaryDisabledSubdued,
    checkboxBackgroundColorUnselectedDefault: tokens.themePageDefault,
    checkboxBackgroundColorUnselectedHover: tokens.themeActionPrimaryHover,
    checkboxBackgroundColorUnselectedPressed: tokens.themeActionPrimaryPressed,
    checkboxBackgroundColorUnselectedDisabled: tokens.themeActionNeutralDisabled,
    checkboxBorderWidth: 1,
    checkboxBorderRadius: 4,
    checkboxBorderColorSelectedDefault: "rgba(0, 0, 0, 0)",
    checkboxBorderColorSelectedDisabled: tokens.themeBorderDisabled,
    checkboxBorderColorUnselectedDefault: tokens.themeBorderFormfield,
    checkboxBorderColorUnselectedHover: "rgba(0, 0, 0, 0)",
    checkboxBorderColorUnselectedPressed: "rgba(0, 0, 0, 0)",
    checkboxBorderColorUnselectedDisabled: tokens.themeBorderDisabled,
    checkboxIndicatorColorSelectedDefault: tokens.themeInkInverse,
    checkboxIndicatorColorSelectedDisabled: tokens.themeActionNeutralDisabled,
    checkboxIndicatorColorUnselectedDefault: "rgba(0, 0, 0, 0)",
    checkboxIndicatorColorUnselectedHover: tokens.themeActionPrimaryDefault,
    checkboxIndicatorColorUnselectedPressed: tokens.themeInkInverse,
    checkboxWidthSmall: 20,
    checkboxWidthMedium: 20,
    checkboxWidthLarge: 24,
    checkboxHeightSmall: 20,
    checkboxHeightMedium: 20,
    checkboxHeightLarge: 24,
    checkboxSpacingHorizontal: 12
  }
};